<template>
  <section class="jd-faq hp-animate" v-if="job && faqs.length">
    <h2 class="jd-section-title">Frequently asked questions</h2>
    <p class="jd-faq__intro">
      {{ job.company_name }} is hiring {{ job.job_designation }} in {{ job.cities.join(', ') }}.
    </p>

    <div class="jd-faq__list">
      <div
        class="jd-faq__item"
        :class="{ 'jd-faq__item--open': openIndex === index }"
        v-for="(item, index) in visibleFaqs"
        :key="index"
      >
        <button
          type="button"
          class="jd-faq__question"
          :aria-expanded="openIndex === index ? 'true' : 'false'"
          @click="toggle(index)"
        >
          <span class="jd-faq__question-text">{{ item.question }}</span>
          <span class="jd-faq__icon" aria-hidden="true">{{ openIndex === index ? '−' : '+' }}</span>
        </button>
        <div
          class="jd-faq__answer"
          v-show="openIndex === index"
          v-html="item.answer"
        ></div>
      </div>
    </div>

    <button v-if="!showAll && extraFaqs.length" type="button" class="hp-btn hp-btn--ghost jd-faq__more" @click="showAll = true">
      Read more FAQ
    </button>
  </section>
</template>

<script>
export default {
  name: 'JobDetailFaq',
  props: {
    job: { type: Object, default: null },
    faqs: { type: Array, default: () => [] },
  },
  data() {
    return {
      openIndex: null,
      showAll: false,
    };
  },
  computed: {
    visibleFaqs() {
      return this.showAll ? this.faqs : this.faqs.slice(0, 4);
    },
    extraFaqs() {
      return this.faqs.slice(4);
    },
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>
